"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Background = void 0;
var react_1 = __importStar(require("react"));
var arrays_1 = require("utils/arrays");
var components_1 = require("../components");
var nums = (0, arrays_1.range)(1, 8);
var element = "fill px1 py5";
var wrapper = "d-f ta-center";
var Background = function () { return (react_1.default.createElement(components_1.Section, { examples: react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", { className: "".concat(wrapper, " light1") }, nums.map(function (val) { return (react_1.default.createElement("p", { className: "".concat(element, " bg-dark").concat(val), key: val }, "bg-dark".concat(val))); })),
        react_1.default.createElement("div", { className: "".concat(wrapper, " dark1") }, nums.map(function (val) { return (react_1.default.createElement("p", { className: "".concat(element, " bg-light").concat(val), key: val }, "bg-light".concat(val))); })),
        react_1.default.createElement("div", { className: wrapper }, nums.map(function (val) { return (react_1.default.createElement("p", { className: "".concat(element, " bg-primary").concat(val, " ").concat(val <= 4 ? "light" : "dark", "1"), key: val }, "bg-primary".concat(val))); })),
        react_1.default.createElement("div", { className: wrapper }, nums.map(function (val) { return (react_1.default.createElement("p", { className: "".concat(element, " bg-secondary").concat(val, " ").concat(val <= 4 ? "light" : "dark", "1"), key: val }, "bg-secondary".concat(val))); }))), id: "background", title: "Background" })); };
exports.Background = Background;
